import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Message, Row, Col, ControlLabel } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
import { v4 as uuidv4 } from 'uuid'
import { doneLoading, startLoading } from '../../utils/loading'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import {
  getProgressReportSubprojectClose,
  saveBeneficiary,
} from '../../redux/actions/progressReportSubproject'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function BeneficiaryWidget({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  progressActivityId,
  setProgressReportsId = () => {},
  installmentPlanId,
  disabled,
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressValue, setProgressValue] = useState(null)
  const [progressFilesValue, setProgressFilesValue] = useState(null)
  const [conduciveHealthValue, setConduciveHealthValue] = useState(null)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setFormSchema(_schema)
    setProgressFilesValue(_schema?.healthInnovation?.values || null)
    setConduciveHealthValue(formSchema?.conduciveHealth?.values || null)

    setProgressValue(_schema?.values || null)
  }, [_schema])

  const onSubmit = (data) => {
    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period || 0,
      installmentPlanDetailId: installmentPlanId,
      progressActivityId: progressActivityId || '',
      directBeneficiariesNo: data.spAmountInput || 0,
      directHealthBehaviors: data.spHealthPromotingInput || '',
      indirectBeneficiariesNo: data.iwAmountInput || 0,
      inirectHealthBehaviors: data.iwHealthPromotingInput || '',
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveBeneficiary(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.otherOutcomes)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  return (
    <div>
      <Panel
        header={formSchema.beneficiary.title}
        collapsible
        defaultExpanded
        style={{ marginTop: 10 }}
      >
        <div style={{ paddingLeft: 30, paddingRight: 0, marginTop: -20 }}>
          <h6>{formSchema.beneficiary.straightPath.title}</h6>
          {formSchema.beneficiary.straightPath.note && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={22} md={22} sm={22} xs={22}>
                  <Message
                    showIcon
                    type="info"
                    description={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: formSchema.beneficiary.straightPath.note,
                        }}
                      />
                    }
                  />
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}></Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={6} xs={6}>
              {!disabled ? (
                <>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.beneficiary.straightPath.spAmountInput.validators) &&
                        'required'
                    )}
                  >
                    {formSchema.beneficiary.straightPath.spAmountInput.label}
                  </ControlLabel>
                  <InputForm
                    schema={formSchema.beneficiary.straightPath.spAmountInput}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                    isInputNumber={true}
                  />
                </>
              ) : (
                <>
                  <b>{formSchema.beneficiary.straightPath.spAmountInput.label}</b>
                  <p>{formSchema.beneficiary.straightPath.spAmountInput.value}</p>
                </>
              )}
            </Col>
            <Col lg={16} md={16} sm={16} xs={16}>
              {!disabled ? (
                <>
                  <ControlLabel
                    className={classNames(
                      isRequired(
                        formSchema.beneficiary.straightPath.spHealthPromotingInput.validators
                      ) && 'required'
                    )}
                  >
                    {formSchema.beneficiary.straightPath.spHealthPromotingInput.label}
                  </ControlLabel>
                  <InputForm
                    schema={formSchema.beneficiary.straightPath.spHealthPromotingInput}
                    placeholder={
                      'ระบุ' + formSchema.beneficiary.straightPath.spHealthPromotingInput.label
                    }
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                  />
                </>
              ) : (
                <>
                  <b> {formSchema.beneficiary.straightPath.spHealthPromotingInput.label}</b>
                  <p>{formSchema.beneficiary.straightPath.spHealthPromotingInput.value}</p>
                </>
              )}
            </Col>
            <Col lg={2} md={2} sm={2} xs={2}></Col>
          </Row>
        </div>
        <div style={{ paddingLeft: 30, paddingRight: 0, marginTop: 40 }}>
          <h6>{formSchema.beneficiary.indirectWay.title}</h6>
          {formSchema.beneficiary.indirectWay.note && (
            <>
              <Row style={{ marginTop: 10 }}>
                <Col lg={22} md={22} sm={22} xs={22}>
                  <Message
                    showIcon
                    type="info"
                    description={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: formSchema.beneficiary.indirectWay.note,
                        }}
                      />
                    }
                  />
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}></Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={6} xs={6}>
              {!disabled ? (
                <>
                  <ControlLabel
                    className={classNames(
                      isRequired(formSchema.beneficiary.indirectWay.iwAmountInput.validators) &&
                        'required'
                    )}
                  >
                    {formSchema.beneficiary.indirectWay.iwAmountInput.label}
                  </ControlLabel>
                  <InputForm
                    schema={formSchema.beneficiary.indirectWay.iwAmountInput}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                    isInputNumber={true}
                  />
                </>
              ) : (
                <>
                  <b> {formSchema.beneficiary.indirectWay.iwAmountInput.label}</b>
                  <p>{formSchema.beneficiary.indirectWay.iwAmountInput.value}</p>
                </>
              )}
            </Col>
            <Col lg={16} md={16} sm={16} xs={16}>
              {!disabled ? (
                <>
                  <ControlLabel
                    className={classNames(
                      isRequired(
                        formSchema.beneficiary.indirectWay.iwHealthPromotingInput.validators
                      ) && 'required'
                    )}
                  >
                    {formSchema.beneficiary.indirectWay.iwHealthPromotingInput.label}
                  </ControlLabel>
                  <InputForm
                    schema={formSchema.beneficiary.indirectWay.iwHealthPromotingInput}
                    placeholder={
                      'ระบุ' + formSchema.beneficiary.indirectWay.iwHealthPromotingInput.label
                    }
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                  />
                </>
              ) : (
                <>
                  <b> {formSchema.beneficiary.indirectWay.iwHealthPromotingInput.label}</b>
                  <p>{formSchema.beneficiary.indirectWay.iwHealthPromotingInput.value}</p>
                </>
              )}
            </Col>
            <Col lg={2} md={2} sm={2} xs={2}></Col>
          </Row>
        </div>
        {!disabled && (
          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </div>
  )
}
